// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type OptionCardUtils_WouldDeselectFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isSingleOptionGroup: boolean } };

export const OptionCardUtils_WouldDeselectFragmentDoc = gql`
    fragment OptionCardUtils_WouldDeselect on ReadyPlanOption {
  id
  name
  optionGroup {
    id
    name
    isSingleOptionGroup
  }
}
    `;